export const notionTranslations = {
  ar: {
    title: 'مزامنة الأجهزة عبر Notion',
    exportDeviceInfo: 'تصدير معلومات الجهاز',
    exportDescription: 'قم بحفظ معلومات الجهاز في Notion لمشاركتها مع الأجهزة الأخرى',
    downloadFile: 'تحميل الملف',
    downloadAndOpen: 'تحميل وفتح',
    saveToNotion: 'حفظ في Notion',
    uploading: 'جاري الرفع...',
    importDeviceInfo: 'استيراد معلومات جهاز',
    importDescription: 'قم بتحميل ملف JSON أو قراءة البيانات من Notion لاستيراد معلومات جهاز آخر',
    selectedFile: 'الملف المحدد',
    importing: 'جاري الاستيراد...',
    importFromFile: 'استيراد من ملف',
    loadingFromNotion: 'جاري التحميل...',
    loadFromNotion: 'تحميل من Notion',
    importedDeviceInfo: 'معلومات الجهاز المستورد',
    deviceName: 'اسم الجهاز',
    deviceId: 'معرف الجهاز',
    apiUrl: 'عنوان API',
    saveSuccess: '✅ تم حفظ البيانات في Notion بنجاح!',
    saveError: 'فشل حفظ البيانات',
    noData: 'لا توجد بيانات في Notion',
    importSuccess: 'تم استيراد معلومات الجهاز بنجاح!',
    importError: 'خطأ في استيراد الملف',
    fileDownloaded: 'تم تحميل ملف معلومات الجهاز.',
  },
  en: {
    title: 'Sync Devices via Notion',
    exportDeviceInfo: 'Export Device Info',
    exportDescription: 'Save device info to Notion to share with other devices',
    downloadFile: 'Download File',
    downloadAndOpen: 'Download & Open',
    saveToNotion: 'Save to Notion',
    uploading: 'Uploading...',
    importDeviceInfo: 'Import Device Info',
    importDescription: 'Download a JSON file or read from Notion to import another device\'s info',
    selectedFile: 'Selected file',
    importing: 'Importing...',
    importFromFile: 'Import from File',
    loadingFromNotion: 'Loading...',
    loadFromNotion: 'Load from Notion',
    importedDeviceInfo: 'Imported Device Info',
    deviceName: 'Device Name',
    deviceId: 'Device ID',
    apiUrl: 'API URL',
    saveSuccess: '✅ Data saved to Notion successfully!',
    saveError: 'Failed to save data',
    noData: 'No data found in Notion',
    importSuccess: 'Device info imported successfully!',
    importError: 'Error importing file',
    fileDownloaded: 'Device info file downloaded.',
  }
};
